module.exports = __webpack_public_path__ + "img/44-image-1-1@2x.07bdf94c.png";